<template>
  <div class="mose" :class="is_http_type == true ? 'show' : ''">
    <div class="url">
      <p>
        请使用“https://v.jingjiribao.cn/newcommunity/#/login?state=1”访问网站
      </p>
      <a href="https://v.jingjiribao.cn/newcommunity/#/login?state=1"
        >{{ count }}后自动跳转</a
      >
    </div>
  </div>
</template>

<script>
export default {
  props: ["router_url"],
  data() {
    return {
      is_http_type: false,
      count: "", //倒计时
    };
  },
  computed: {},
  watch: {},
  created() {
    this.is_http();
    if (this.is_http_type) {
      //自动跳转页面
      this.clickJump();
    }
  },
  mounted() {},
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); //关闭
    }
  },
  methods: {
    //几秒后进入跳转页面
    clickJump() {
      const timejump = 3;
      if (!this.timer) {
        this.count = timejump;
        this.show = false;
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= timejump) {
            this.count--;
          } else {
            this.show = true;
            clearInterval(this.timer);
            this.timer = null;
            //跳转的页面写在此处
            // this.$router.push({ path: '/community' });
            // location.href = 'https://v.jingjiribao.cn/newcommunity/#/login?state=1'
            window.location.href =
              "https://v.jingjiribao.cn/newcommunity/#/login?state=1";
          }
        }, 1000);
      }
    },

    is_http() {
      const ishttps = "https:" == document.location.protocol ? true : false;
      var isUrl = "https";
      if (ishttps) {
        isUrl = "https";
      } else {
        this.is_http_type = true; //显示http弹窗

        isUrl = "http";
      }
    },
  },
};
</script>

<style scoped>
.mose {
  display: none;
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 9999;
}
.show {
  display: block;
}
.url {
  width: 35%;
  padding: 30px 10px;
  box-sizing: border-box;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: #fff;
  border-radius: 10px;
}
.url p {
  color: #333;
  font-size: 0.16rem;
}
.url a {
  color: #d4011a;
  display: block;
  margin-top: 10px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/common/is_http.vue